module.exports = __webpack_public_path__ + "static/media/arrow-left-black.38f1333e.png";